"use strict";

require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.string.trim");
require("core-js/modules/es6.promise");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
require("jquery-validation");
require("jquery-validation/dist/additional-methods");
var Languages_1 = require("../../Core/Languages");
var PhonePL_rule_1 = require("../Validation/Rules/PhonePL.rule");
var PostalPL_rule_1 = require("../Validation/Rules/PostalPL.rule");
var Nip_rule_1 = require("../Validation/Rules/Nip.rule");
var PasswordRules_1 = require("./Rules/PasswordRules");
var Email_rule_1 = require("../Validation/Rules/Email.rule");
var StrongPassword_rule_1 = require("./Rules/StrongPassword.rule");
exports.ValidationModule = function () {
  if (Languages_1.Languages.Current.key == 'pl') {
    Promise.resolve().then(function () {
      return require('jquery-validation/dist/localization/messages_pl');
    });
    $.extend($.validator.messages, {
      reCaptcha: 'Pole reCAPTCHA musi być zaznaczone.',
      phonePL: 'Proszę o podanie przynajmniej 9 znaków.',
      require_from_group: 'Jedno z pól musi być zaznaczone'
    });
  } else if (Languages_1.Languages.Current.key == 'ru') {
    Promise.resolve().then(function () {
      return require('jquery-validation/dist/localization/messages_ru');
    });
    $.extend($.validator.messages, {
      reCaptcha: 'Установите флажок reCAPTCHA.',
      phonePL: 'Пожалуйста, введите не менее 9 символов.',
      require_from_group: 'Один из квадратов должен быть отмечен'
    });
  } else {
    $.extend($.validator.messages, {
      reCaptcha: 'The reCAPTCHA box must be checked.',
      phonePL: 'Please enter at least 9 characters.'
    });
  }
  var config = {
    onkeyup: function onkeyup(element) {
      return $(element).valid();
    },
    lang: Languages_1.Languages.Current.key,
    errorElement: 'div',
    errorClass: 'invalid-feedback',
    normalizer: function normalizer(value) {
      return $.trim(value);
    },
    highlight: function highlight(element, errorClass) {
      return $(element).addClass('is-invalid').removeClass(errorClass);
    },
    unhighlight: function unhighlight(element, errorClass) {
      return $(element).removeClass('is-invalid').removeClass(errorClass);
    }
  };
  $.validator.setDefaults(config);
  var rules = {
    StrongPasswordRule: StrongPassword_rule_1.StrongPasswordRule,
    PhonePLRule: PhonePL_rule_1.PhonePLRule,
    PostalPLRule: PostalPL_rule_1.PostalPLRule,
    NipRule: Nip_rule_1.NipRule,
    EmailRule: Email_rule_1.EmailRule
  };
  Object.assign({
    rules: rules
  }, new PasswordRules_1.PasswordRules().passwordRule());
}();